import loginTypes from '../login/loginTypes'
import types from './portfolioTypes'

let initialState = {
    groupsList: [],
    studentsList: [],
    filesList: [],
}

const portfolioReducer = (state = initialState, action: any) => {
    switch (action.type) {

        // Выход из системы
        case loginTypes.LOGIN_SET_LOGOUT: {
            return {
                ...state = initialState
            }
        }

        // Получение списка групп оператора
        case types.PORTFOLIO_SET_GROUPS: {
            return {
                ...state,
                groupsList: action.items
            }
        }

        // Получение списка студентов
        case types.PORTFOLIO_SET_STUDENTS: {
            return {
                ...state,
                studentsList: action.items
            }
        }

        // Получение списка файлов
        case types.PORTFOLIO_SET_FILES: {
            return {
                ...state,
                filesList: action.items
            }
        }

        default: return state
    }
}

export default portfolioReducer